export default __webpack_public_path__ + "static/media/Onboardlogo.a2f9d0f1.svg";